import Hero from './components/Hero';
import Mission from './components/Mission';
import Values from './components/Values';
import Strengths from './components/Strengths';
import Operations from './components/Operations';
import Stats from './components/Stats';

export default function About() {
  return (
    <div className="min-h-screen">
      <Hero />
      <Mission />
      <Values />
      <Strengths />
      <Operations />
      <Stats />
    </div>
  );
}
